import download from "../../../vendors/download.min.js";

function cardCreator() {
	const cardCreator = document.querySelector('[data-js="CardCreator"]');

	if (cardCreator) {
		const cardFileName = cardCreator.getAttribute("data-file-name");
		const gtmCategory = cardCreator.getAttribute("data-gtm-category");
		const cardGreetings = cardCreator
			.querySelector("[data-greetings-text]")
			.getAttribute("data-greetings-text");

		const mainColor = getComputedStyle(cardCreator).getPropertyValue(
			"--main-color"
		);
		var CreatorConfig = {
			gtmCategory: gtmCategory,
			cardGreeting: cardGreetings,
			cards: {
				// kartki z własnym obrazkiem
				own: [
					// kartka 1
					{
						desktop: {
							size: 0,
							imageOffsetX: 0,
							imageOffsetY: 0,
							textOffsetX: 0,
							textOffsetY: 0,
							rotation: 0,
						},
						mobile: {
							size: 0,
							imageOffsetX: 0,
							imageOffsetY: 0,
							textOffsetX: 0,
							textOffsetY: 0,
							rotation: 0,
						},
					},
					// kartka 2
					{},
					// kartka 3
					{},
					// kartka 4
					{},
				],
				// kartki gotowe
				predefined: [
					// kartka 1
					{
						desktop: {},
						mobile: {},
					},
					// kartka 2
					{
						desktop: {},
						mobile: {},
					},
					// kartka 3
					{
						desktop: {},
						mobile: {},
					},
					// kartka 4
					{
						desktop: {},
						mobile: {},
					},
				],
			},
		};

		var CreatorConstants = {
			appDivId: cardCreator.id,
			generatedFileName: cardFileName,
			canvasId: "card-canvas",
		};
		let waitForFinalEvent = (function () {
			var timers = {};
			return function (callback, ms, uniqueId) {
				if (!uniqueId) {
					uniqueId = "Don't call this twice without a uniqueId";
				}
				if (timers[uniqueId]) {
					clearTimeout(timers[uniqueId]);
				}
				timers[uniqueId] = setTimeout(callback, ms);
			};
		})();

		let isMobile = {
			Android: function () {
				return navigator.userAgent.match(/Android/i);
			},
			BlackBerry: function () {
				return navigator.userAgent.match(/BlackBerry/i);
			},
			iOS: function () {
				return navigator.userAgent.match(/iPhone|iPad|iPod/i);
			},
			Opera: function () {
				return navigator.userAgent.match(/Opera Mini/i);
			},
			Windows: function () {
				return (
					navigator.userAgent.match(/IEMobile/i) ||
					navigator.userAgent.match(/WPDesktop/i)
				);
			},
			any: function () {
				return (
					isMobile.Android() ||
					isMobile.BlackBerry() ||
					isMobile.iOS() ||
					isMobile.Opera() ||
					isMobile.Windows()
				);
			},
		};

		let get_browser = function () {
			var ua = navigator.userAgent,
				tem,
				M =
					ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) ||
					[];
			if (/trident/i.test(M[1])) {
				tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
				return { name: "IE", version: tem[1] || "" };
			}
			if (M[1] === "Chrome") {
				tem = ua.match(/\bOPR|Edge\/(\d+)/);
				if (tem != null) {
					return { name: "Opera", version: tem[1] };
				}
			}
			M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
			if ((tem = ua.match(/version\/(\d+)/i)) != null) {
				M.splice(1, 1, tem[1]);
			}

			return {
				name: M[0],
				version: M[1],
			};
		};

		///////////////////////////////////////////////////////////////////////////////////

		let App = {
			debug: false, // true | false
			debugImg: false, // true | false
			cardData: {
				cardType: null, // ownCard | predefinedCard
				cardStyle: 0, // 0,1,2,3
				greetingsType: 0, // 0,1,2,3
				greetingsText: "",
				imageBase64: null,
			},
			cropitConfig: {},
			cardImage: null,
			canvas: null,
			ctx: null,
			canCreateImage: false,
			device: function () {
				return window.innerWidth <= 768 && isMobile.any() ? "mobile" : "desktop";
			},
			dev: function () {
				$(".screen-1").each(function () {
					let breakpoint = window.getComputedStyle(this, ":before").content;
					// console.log(breakpoint);
					$("title").text(breakpoint);
				});
			},
			showCardData: function () {
				if (App.debug) console.log("showCardData");

				// if (this.debug) console.table(App.cardData);
			},
			resetCardData: function () {
				this.cardData = {
					cardType: null,
					cardStyle: 0,
					greetingsType: 0,
					greetingsText: "",
					imageBase64: null,
				};
				$(".tmp-signature-2, .greetingsText span").empty();
				$("textarea.greetingsText").val("Miejsce na Twój podpis");
				$(".tmp-signature-2").text("Miejsce na Twój podpis");

				if ($(".own-card-style.slick-slider").length !== 0) {
					$(".own-card-style").slick("slickGoTo", 0);
				}
				if ($(".own-card-style.slick-slider").length !== 0) {
					$(".predefined-card-style").slick("slickGoTo", 0);
				}
			},
			nav: {
				goto: function (screenId) {
					let screenName = screenId.substr(4);

					// reset card data after restart
					if (screenName == CreatorConstants.appDivId + "-2") {
						App.resetCardData();
						App.resetCropit();
					}

					// screen2, set cardType
					if (screenName == CreatorConstants.appDivId + "-8-1") {
						App.cardData.cardType = "ownCard";
					} else if (screenName == CreatorConstants.appDivId + "-3-1") {
						App.cardData.cardType = "predefinedCard";
					}

					// screen6, after card type select
					if (screenName == CreatorConstants.appDivId + "-4-1") {
						//own card images paths
						const ownCardCont = cardCreator.querySelector(".own-card-style");
						// --> desktop
						const ownCardDesktopCont = ownCardCont.querySelectorAll(".desktop");
						var ownCardDesktopImages = [];
						// -> mobile
						const ownCardMobileCont = ownCardCont.querySelectorAll(".mobile");
						var ownCardMobileImages = [];

						// predefined card images paths
						const predefinedCardCont = cardCreator.querySelector(
							".predefined-card-style"
						);
						// --> desktop
						const predefinedCardDesktopCont = predefinedCardCont.querySelectorAll(
							".desktop"
						);
						var predefinedCardDesktopImages = [];
						// -> mobile
						const predefinedCardMobileCont = predefinedCardCont.querySelectorAll(
							".mobile"
						);
						var predefinedCardMobileImages = [];

						let getImages = function (container, imgArr) {
							container.forEach((element) => {
								const image = element.querySelector("img");
								const imageSrc = image.getAttribute("data-src");
								imgArr.push(imageSrc);
							});
						};
						getImages(ownCardDesktopCont, ownCardDesktopImages);
						getImages(ownCardMobileCont, ownCardMobileImages);
						getImages(predefinedCardDesktopCont, predefinedCardDesktopImages);
						getImages(predefinedCardMobileCont, predefinedCardMobileImages);

						if (App.cardData.cardType == "ownCard") {
							if (App.device() == "mobile") {
								$(".selectedCardImg").attr(
									"src",
									`${ownCardMobileImages[App.cardData.cardStyle]}`
								);
							} else if (App.device() == "desktop") {
								$(".selectedCardImg").attr(
									"src",
									`${ownCardDesktopImages[App.cardData.cardStyle]}`
								);
							}
						} else {
							if (App.device() == "mobile") {
								$(".selectedCardImg").attr(
									"src",
									`${predefinedCardMobileImages[App.cardData.cardStyle]}`
								);
							} else if (App.device() == "desktop") {
								$(".selectedCardImg").attr(
									"src",
									`${predefinedCardDesktopImages[App.cardData.cardStyle]}`
								);
							}
						}

						var img = new Image();
						img.onload = function () {
							App.canvas = document.createElement("canvas");
							App.ctx = App.canvas.getContext("2d");
							App.canvas.id = CreatorConstants.canvasId;
							App.canvas.setAttribute("width", this.width + "px");
							App.canvas.setAttribute("height", this.height + "px");
							App.cardImage = this;
							App.canCreateImage = true;
						};

						//img.src = "../../../Netia/media/kartka/walentynki-2021/selected-" + App.cardData.cardType + "-" + CreatorConstants.appDivId + "-" + App.cardData.cardStyle + "-" + App.device() + "@2x.png";

						if (App.cardData.cardType == "ownCard") {
							if (App.device() == "mobile") {
								img.src = `${ownCardMobileImages[App.cardData.cardStyle]}`;
							} else if (App.device() == "desktop") {
								img.src = `${ownCardDesktopImages[App.cardData.cardStyle]}`;
							}
						} else {
							if (App.device() == "mobile") {
								img.src = `${predefinedCardMobileImages[App.cardData.cardStyle]}`;
							} else if (App.device() == "desktop") {
								img.src = `${predefinedCardDesktopImages[App.cardData.cardStyle]}`;
							}
						}
					}
					// screen7, after greetings select
					if (screenName == CreatorConstants.appDivId + "-5-1") {
						const greetingsCont = cardCreator.querySelector(".greetings");
						const greetings = greetingsCont.querySelectorAll("img");
						const greetingsArr = [];
						greetings.forEach((greeting) => {
							var greetingPath = greeting.getAttribute("src");
							greetingsArr.push(greetingPath);
						});
						$(".selectedGreetingsImg").attr(
							"src",
							`${greetingsArr[App.cardData.greetingsType]}`
						);
					}

					// validate before last screen
					if (screenName == CreatorConstants.appDivId + "-6") {
						if (
							$("textarea.greetingsText").val().replace(" ", "") ==
								"Miejscena Twój podpis" ||
							$("textarea.greetingsText").val().length == 0
						) {
							$(".error").fadeIn();
							$("textarea.greetingsText").val("").focus();
							return;
						}
					}

					// back button fix
					if (screenName == `${CreatorConstants.appDivId}-9`) {
						if (App.cardData.cardType == "ownCard") {
							screenName = `${CreatorConstants.appDivId}-9`;

							// if photo is selected
							if (typeof $(".cropit-preview-image").attr("src") !== "undefined") {
								let imageBase64 = $(".image-editor").cropit("export");
								//window.open(imageBase64);
								App.cardData.imageBase64 = imageBase64;
								$("#imageBase64").attr("src", imageBase64);
								$("#imageBase64-2").attr("src", imageBase64);
								$("#imageBase64-3").attr("src", imageBase64);
								$("#imageBase64-4").attr("src", imageBase64);

								$("#imageBase64-2, #imageBase64-3, #imageBase64-4").show();
							} else {
								return false;
							}
						} else {
							screenName = `${CreatorConstants.appDivId}-3-1`;
						}
					}
					// show steps for ownCard or predefinedCard
					if (App.debug) console.log(App.cardData.cardType);
					$(".ownCard, .predefinedCard").hide();
					$("." + App.cardData.cardType).show();

					// show screen
					$(".screen").hide();
					$("#" + screenName).show();

					App.showCardData();
					if (
						screenName === `${CreatorConstants.appDivId}-9` ||
						screenName === `${CreatorConstants.appDivId}-3-1` ||
						screenName === `${CreatorConstants.appDivId}-4-1`
					) {
						App.startSlick();
					}
				},
			},

			startSlick: function () {
				if ($(".own-card-style.slick-slider").length == 0) {
					if (App.debug) console.log(">> start own-card-style slider");
					$(".own-card-style").slick({
						dots: true,
						infinite: false,
						speed: 500,
						fade: true,
						cssEase: "linear",
						dotsClass: "slick-dots",
					});
				} else {
					if (App.debug) console.log(">> setposition own-card-style");
					setTimeout(function () {
						$(".own-card-style").slick("setPosition");
					}, 25);
				}
				if ($(".predefined-card-style.slick-slider").length == 0) {
					if (App.debug) console.log(">> start predefined-card-style slider");
					$(".predefined-card-style").slick({
						dots: true,
						infinite: false,
						speed: 500,
						fade: true,
						cssEase: "linear",
						dotsClass: "slick-dots",
					});
				} else {
					if (App.debug) console.log(">> setposition predefined-card-style");
					setTimeout(function () {
						$(".predefined-card-style").slick("setPosition");
					}, 25);
				}

				if ($(".greetings.slick-slider").length == 0) {
					if (App.debug) console.log(">> start greetings slider");
					$(".greetings").slick({
						dots: true,
						infinite: false,
						speed: 150,
						fade: true,
						cssEase: "linear",
						dotsClass: "slick-dots",
					});
				} else {
					if (App.debug) console.log(">> setposition greetings");
					setTimeout(function () {
						$(".greetings").slick("setPosition");
					}, 25);
				}

				if (window.innerWidth <= 768) {
					App.filterSlick("mobile");
				} else {
					App.filterSlick("desktop");
				}
			},
			filterSlick: function (device) {
				if (App.debug) console.log(">> filterSlick " + device);

				let deviceKey = device;

				$(".predefined-card-style").slick("slickUnfilter");
				$(".predefined-card-style").slick("slickFilter", function (i, e) {
					return $(e).hasClass(deviceKey);
				});
				//$(".predefined-card-style").slick('slickGoTo', 0);

				$(".own-card-style").slick("slickUnfilter");
				$(".own-card-style").slick("slickFilter", function (i, e) {
					return $(e).hasClass(deviceKey);
				});
				//$(".own-card-style").slick('slickGoTo', 0);
			},
			startCropit: function () {
				if (App.debug) console.log(">> start cropit");

				const cropitView = cardCreator
					.querySelector(".cropit-preview")
					.getBoundingClientRect();
				this.cropitConfig.width = cropitView.width * 2;
				this.cropitConfig.height = cropitView.height * 2;
				// 	this.cropitConfig.height = 500;
				// if (this.device() == "desktop") {
				// 	// w.width 769+
				// 	this.cropitConfig.width = 562; // 280
				// 	this.cropitConfig.height = 562;
				// } else if (this.device() == "mobile" && window.width > 640) {
				// 	// w.width 641-768
				// 	this.cropitConfig.width = 760; // 380
				// 	this.cropitConfig.height = 760;
				// } else {
				// 	// w.width < 640
				// 	this.cropitConfig.width = 500; //250
				// 	this.cropitConfig.height = 500;
				// }

				$(".image-editor").cropit({
					allowDragNDrop: true,
					type: "image/jpeg",
					// exportZoom: 2,
					width: App.cropitConfig.width,
					height: App.cropitConfig.width,
					freeMove: true,
					minZoom: "fill",
					smallImage: "stretch",
					// imageBackground: true,
					onImageLoaded: function () {
						$(".requirements").hide();
						$(".change-photo").show();
						$(".cropit-preview-image-container").show();
					},
					onFileReaderError: function (e) {
						if (App.debug) console.log("onFileReaderError:");
						if (App.debug) console.dir(e);
					},
					onImageError: function (e) {
						if (App.debug) console.log("onImageError: ");
						if (App.debug) console.dir(e);
					},
				});
			},
			resetCropit: function () {
				if (App.debug) console.log("resetCropit");

				if ($("input.cropit-image-input")[0].value !== "") {
					$("input.cropit-image-input").val("");
					$(".cropit-preview").removeClass("cropit-image-loaded");
					$(".cropit-preview-image").removeAttr("style");
					$(".cropit-preview-image").removeAttr("src");
					$(".cropit-preview-image-container").hide();

					//$(".image-editor").empty().append('<input type="file" class="cropit-image-input"><div class="cropit-preview"></div>');
				}
			},
			getDateTime: function () {
				let d = new Date();
				let curr_date = d.getDate();
				let curr_month = d.getMonth() + 1;
				let curr_year = d.getFullYear();
				let hours = d.getHours();
				let minutes = d.getMinutes();

				return (
					curr_year +
					"-" +
					curr_month +
					"-" +
					curr_date +
					"-" +
					hours +
					"-" +
					minutes
				);
			},
			events: function () {
				let _this = this;

				$(".button-nav").on("click", function () {
					let screenId = $(this).data("goto");
					if (_this.debug) console.log("goto: " + screenId);
					_this.nav.goto(screenId);

					// if (
					// 	screenId == "btn-CardCreator-3-1" ||
					// 	screenId == "btn-CardCreator-4-1"
					// ) {
					// 	_this.startSlick();
					// }
					if (screenId == "btn-CardCreator-8-1") {
						_this.startCropit();
					}
				});
				$(".screen-2-img-1").on("click", function () {
					$(".screen-2-btn-1").click();
				});
				$(".screen-2-img-2").on("click", function () {
					$(".screen-2-btn-2").click();
				});

				$(".cropit-preview").on("click", function () {
					if (typeof $(".cropit-preview-image").attr("src") === "undefined") {
						$(".cropit-image-input").click();
					}
				});
				$(".btn-change-photo, .cropit-preview-image-container").on(
					"click",
					function () {
						_this.resetCropit();
						$(".cropit-image-input").click();
					}
				);

				$(".btn-rotate-photo").on("click", function () {
					$(".image-editor").cropit("rotateCW");
				});

				$(".predefined-card-style").on(
					"afterChange",
					function (event, slick, currentSlide) {
						if (_this.debug)
							console.log("selected card style: " + slick.currentSlide);
						_this.cardData.cardStyle = slick.currentSlide;
						_this.showCardData();
					}
				);

				$(".own-card-style").on(
					"beforeChange",
					function (event, slick, currentSlide, nextSlide) {
						if (_this.debug) console.log("selected card style: " + nextSlide);
						_this.cardData.cardStyle = nextSlide;

						$("#imageBase64").fadeOut("fast", function () {
							$(this)
								.removeClass("type-0 type-1 type-2 type-3")
								.addClass("type-" + nextSlide);
							$("#imageBase64-2")
								.removeClass("type-0 type-1 type-2 type-3")
								.addClass("type-" + nextSlide);
							$("#imageBase64-3")
								.removeClass("type-0 type-1 type-2 type-3")
								.addClass("type-" + nextSlide);
							$("#imageBase64-4")
								.removeClass("type-0 type-1 type-2 type-3")
								.addClass("type-" + nextSlide);
						});
						_this.showCardData();
					}
				);
				$(".own-card-style").on(
					"afterChange",
					function (event, slick, currentSlide) {
						$("#imageBase64").fadeIn();
						_this.showCardData();
					}
				);

				$(".greetings").on("afterChange", function (event, slick, currentSlide) {
					if (_this.debug)
						console.log("selected greetings style: " + slick.currentSlide);
					_this.cardData.greetingsType = slick.currentSlide;
					_this.showCardData();
				});

				$("textarea.greetingsText").on("click", function () {
					if ($(this).val() == "Miejsce na Twój podpis") {
						$(this).empty().val("");
					}
				});
				$("textarea.greetingsText").on("keyup", function (event) {
					let textarea = $("textarea.greetingsText").val();
					$(".tmp-signature-2, .greetingsText span").text(textarea);
					_this.cardData.greetingsText = textarea;
					$(".error").fadeOut();
				});
				$("textarea.greetingsText").on("blur", function (event) {
					$(".error").fadeOut();
				});

				$(".button-download").on("click", function () {
					if (_this.debug) console.clear();
					if (_this.debug) console.log("create canvas and start download");
					// if (_this.debug) console.table(App.cardData);
					if (App.canCreateImage || App.cardData.cardType === "predefinedCard") {
						var positionData = {
							image: {
								s: 0,
								x: 0,
								y: 0,
								rot: 0,
							},
							text: {
								x: 0,
								y: 0,
							},
						};

						if (App.cardData.cardType === "ownCard") {
							positionData.image.s = App.device() === "mobile" ? 420 : 420;
							positionData.image.x = App.device() === "mobile" ? 170 : 150;
							positionData.image.y = App.device() === "mobile" ? 140 : 150;
							positionData.text.x = App.device() === "mobile" ? 120 : 655;
							positionData.text.y = App.device() === "mobile" ? 700 : 150;

							// 0-3
							// switch (App.cardData.cardStyle) {
							//     case 0:
							//         positionData.image.s = App.device() === 'mobile' ? 440 : 408;
							//         positionData.image.x = App.device() === 'mobile' ? 170 : 150;
							//         positionData.image.y = App.device() === 'mobile' ? 170 : 150;
							//         positionData.text.x = App.device() === 'mobile' ? 140 : 628;
							//         positionData.text.y = App.device() === 'mobile' ? 840 : 150;
							//         break;
							//     case 1:
							//         positionData.image.s = App.device() === 'mobile' ? 490 : 506;
							//         positionData.image.x = App.device() === 'mobile' ? 150 : 100;
							//         positionData.image.y = App.device() === 'mobile' ? 100 : 156;
							//         positionData.text.x = App.device() === 'mobile' ? 140 : 800;
							//         positionData.text.y = App.device() === 'mobile' ? 840 : 184;
							//         break;
							//     case 2:
							//         positionData.image.s = App.device() === 'mobile' ? 440 : 470;
							//         positionData.image.x = App.device() === 'mobile' ? 170 : 170;
							//         positionData.image.y = App.device() === 'mobile' ? 170 : 170;
							//         positionData.text.x = App.device() === 'mobile' ? 140 : 820;
							//         positionData.text.y = App.device() === 'mobile' ? 840 : 170;
							//         break;
							//     case 3:
							//         positionData.image.s = App.device() === 'mobile' ? 420 : 394;
							//         positionData.image.x = App.device() === 'mobile' ? 218 : 180;
							//         positionData.image.y = App.device() === 'mobile' ? 90 : 76;
							//         positionData.text.x = App.device() === 'mobile' ? 140 : 690;
							//         positionData.text.y = App.device() === 'mobile' ? 800 : 115;
							//         // positionData.image.rot = 7;
							//         break;
							//     default:
							//         break;
							// }

							var chosenImage = new Image();
							chosenImage.src = App.cardData.imageBase64;
							//   chosenImage.width = positionData.image.s;
							//   chosenImage.height = positionData.image.s;

							App.ctx.save();
							App.ctx.rotate((positionData.image.rot * Math.PI) / 180);
							App.ctx.drawImage(
								chosenImage,
								positionData.image.x,
								positionData.image.y,
								positionData.image.s,
								positionData.image.s
							);
							App.ctx.restore();
						} else if (App.cardData.cardType === "predefinedCard") {
							positionData.text.x = App.device() === "mobile" ? 120 : 662;
							positionData.text.y = App.device() === "mobile" ? 730 : 140;

							// if (App.cardData.cardStyle === 1) {
							// 	positionData.text.y = App.device() === "mobile" ? 780 : 140;
							// }
						}

						App.ctx.drawImage(App.cardImage, 0, 0);
						// document.body.appendChild(App.canvas);

						// można zrobić konkretny id albo jedną klasę zawierającą ten obrazek i pole tekstowe?
						var greetingsPic = document.getElementsByClassName(
							"selectedGreetingsImg"
						)[1];
						var greetingsPicPositionX =
							App.device() === "mobile"
								? positionData.text.x + 30
								: positionData.text.x;

						App.ctx.drawImage(
							greetingsPic,
							greetingsPicPositionX,
							positionData.text.y - 20
						);

						var greetings = document.getElementsByClassName("greetingsText")[0].value;
						var textPositionBaseX =
							App.device() === "mobile"
								? App.canvas.width * 0.5
								: positionData.text.x + 245;

						var textPositionBaseY =
							positionData.text.y - 30 + greetingsPic.naturalHeight;

						App.ctx.font = "600 26px Montserrat";
						App.ctx.fillStyle = mainColor;
						App.ctx.fillText(
							CreatorConfig.cardGreeting.toUpperCase(),
							textPositionBaseX - 46,
							textPositionBaseY + 40
						);

						// szerokość pola tekstowego
						var textW = 360;
						// App.createWrapText(
						//   App.ctx,
						//   'Lorem ipsum dolor sit amet'.toUpperCase(),
						//   textPositionBaseX - (textW * .5),
						//   textPositionBaseY + 70,
						//   30,
						//   textW
						// );

						App.createWrapText(
							App.ctx,
							greetings.toUpperCase(),
							textPositionBaseX - textW * 0.5,
							textPositionBaseY + 70,
							30,
							textW
						);
						// App.ctx.fillText(
						//   greetings.toUpperCase(),
						//   textPositionBase - greetings.length * 9,
						//   App.cardImage.height - 140
						// );

						if (
							typeof dataLayer !== "undefined" &&
							typeof dataLayer.push === "function"
						) {
							dataLayer.push({
								event: "GAevent",
								"1_category": CreatorConfig.gtmCategory,
								"2_action": "Download",
								"3_label":
									App.cardData.cardType +
									(App.cardData.cardStyle + 1) +
									(App.cardData.greetingsType + 1) +
									" " +
									App.device(),
								"4_value": "",
								// 'eventCallback': function() {},
								// 'eventTimeout': 2000
							});
						}

						if (get_browser().name == "Safari" && get_browser().version < "13") {
							alert(
								"Nie możesz pobrać kartki? Wygląda na to, że Twoja przeglądarka jest nieaktualna. Zaktualizuj ją i spróbuj jeszcze raz."
							);
						}

						download(
							App.canvas.toDataURL("image/jpeg", 1.0),
							CreatorConstants.generatedFileName + "-" + _this.getDateTime() + ".jpg",
							"image/jpeg"
						);
					} else {
						alert("Kartka jeszcze nie jest gotowa, spróbuj pobrać ją jeszcze raz.");
					}
				});
			},
			createWrapText: function (ctx, text, x, y, lh, w) {
				w = w || 0;

				if (w <= 0) {
					ctx.fillText(text, x, y);
					return;
				}
				var wds = text.split(" ");
				var cl = 0;
				var idx = 1;
				while (wds.length > 0 && idx <= wds.length) {
					var str = wds.slice(0, idx).join(" ");
					var wi = ctx.measureText(str).width;
					if (wi > w) {
						if (idx == 1) {
							idx = 2;
						}
						var cw = ctx.measureText(wds.slice(0, idx - 1).join(" ")).width;
						// console.log('cw: ', cw);
						ctx.fillText(
							wds.slice(0, idx - 1).join(" "),
							x + (w * 0.5 - cw * 0.5),
							y + lh * cl
						);
						cl++;
						wds = wds.splice(idx - 1);
						idx = 1;
					} else {
						idx++;
					}
				}
				if (idx > 0) var ccw = ctx.measureText(wds.join(" ")).width;
				// console.log('ccw: ', ccw);
				ctx.fillText(wds.join(" "), x + (w * 0.5 - ccw * 0.5), y + lh * cl);
			},
			setCreatorConfigData: function (url) {},
			init: function () {
				this.events();

				if (this.debug) {
					this.nav.goto(`btn-${CreatorConstants.appDivId}-1`); // dev
					// $(".screen-4").show();
					//this.startSlick();
					//this.startCropit();
				} else {
					$("#" + CreatorConstants.appDivId + "-1").fadeIn("slow"); // prod
				}
			},
		};

		window.App = App;

		waitForFinalEvent(
			function () {
				App.init();
				// alert(window.innerWidth);
			},
			150,
			"resize"
		);

		// window.addEventListener("orientationchange", function (event) {
		// 	window.location.reload(true);
		// });

		// (function () {

		// 	// console.info("ver. 20191213-1200");
		//

		// 	// $(window).on("resize", function () {
		// 	//     console.log("resized");
		// 	//     // App.dev();

		// 	// }).resize();
		// })();
	}
}

export default cardCreator;
